import Vue from 'vue'

const state = {
  baseUri: '/botw/config/visitComp/'
}
const getters = {
}
const actions = {
  searchDong: function (_context, [data, callback]) { // 법정동 조회
    const reqData = {
      level: data.level,
      upperDongCode: data.dongCode
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'dongSearch',
      params: reqData
    }
    console.log('actions dongSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  search: function (_context, [searchParam, callback]) { // 내역 조회
    const reqData = {
      visitCompName: searchParam.visitCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.address,
      dataFlag: String(searchParam.dataFlag),
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: reqData
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [visitCompSeq, callback]) { // 상세 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + visitCompSeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    const reqData = {
      visitCompName: data.visitCompName,
      businessNum: data.businessNum,
      representative: data.representative,
      mainPhoneNum: data.mainPhoneNum,
      fax: data.fax,
      email: data.email,
      dongCode: data.dongCode,
      extraAddress: data.extraAddress,
      detailSpotList: data.detailSpotList,
      dataFlag: String(true),
      // tbFile: data.tbFile,
      fileCode: data.tbFile.fileCode
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    const reqData = {
      visitCompSeq: data.visitCompSeq,
      visitCompName: data.visitCompName,
      representative: data.representative,
      mainPhoneNum: data.mainPhoneNum,
      fax: data.fax,
      email: data.email,
      dongCode: data.dongCode,
      extraAddress: data.extraAddress,
      detailSpotList: data.detailSpotList,
      dataFlag: String(data.dataFlag),
      // tbFile: data.tbFile,
      fileCode: data.tbFile.fileCode,
      descList: data.descList,
      businessNum: data.businessNum
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descInsert: function (_context, [param, callback]) { // 특이사항 등록
    const reqData = {
      // insertUserSeq: param.insertUserSeq,
      visitCompSeq: param.visitCompSeq,
      desc: param.desc
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descInsert',
      data: reqData
    }
    console.log('actions descInsert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descUpdate: function (_context, [param, callback]) { // 특이사항 수정
    const reqData = {
      updateUserSeq: param.updateUserSeq,
      visitCompSeq: param.visitCompSeq,
      visitCompDtlSeq: param.visitCompDtlSeq,
      desc: param.desc
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descUpdate',
      data: reqData
    }
    console.log('actions descUpdate axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  descDelete: function (_context, [param, callback]) { // 특이사항 삭제
    const reqData = {
      visitCompSeq: param.visitCompSeq,
      visitCompDtlSeq: param.visitCompDtlSeq
    }

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'descDelete',
      data: reqData
    }
    console.log('actions descDelete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  spotSearch: function (_context, [data, callback]) { // 현장 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'spotSearch',
      params: data
    }
    console.log('actions spotSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  dupCheck: function (_context, [searchParam, callback]) { // 현장 중복 조회
    const reqData = {
      visitCompSeq: searchParam.visitCompSeq,
      detailSpotList: searchParam.detailSpotList
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'dupCheck',
      data: reqData
    }
    console.log('actions dupCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeUpdate: function (_context, [data, callback]) {
    console.log('fileCodeUpdate : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeUpdate',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  fileCodeInit: function (_context, [data, callback]) {
    console.log('fileCodeInit actions : ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'fileCodeInit',
      data: data
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
